import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EmailTemplate } from '../../domain/model/emailtemplate';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class EmailtemplateService {
    private http = inject(HttpClient);

    public getEmailTemplates(): Observable<EmailTemplate[]> {
        return this.http.get(environment.API_URL + '/admin/emailtemplates') as Observable<EmailTemplate[]>;
    }

    public saveAllEmailTemplates(templates: EmailTemplate[]): Observable<EmailTemplate[]> {
        return this.http.put(environment.API_URL + '/admin/emailtemplates', templates) as Observable<EmailTemplate[]>;
    }

    public sendTestEmail(): Observable<any> {
        return this.http.post(environment.API_URL + '/admin/emailtemplates/sendtestemail',
            {}) as Observable<any>;
    }
}
